import { render, staticRenderFns } from "./seriesComparator.vue?vue&type=template&id=8d2ac314&scoped=true&"
import script from "./seriesComparator.vue?vue&type=script&lang=js&"
export * from "./seriesComparator.vue?vue&type=script&lang=js&"
import style0 from "./seriesComparator.vue?vue&type=style&index=0&id=8d2ac314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2ac314",
  null
  
)

export default component.exports